import repeatBlackIcon from "../../assets/img/modals/repeat-black.svg";
import repeatIcon from "../../assets/img/modals/repeat.svg";
import integration_google_analytics from "../../assets/img/modals/integration-google-analytics.svg";
import integration_facebook_analytics from "../../assets/img/modals/integration-facebook-pixel.svg";
import integration_mailchimp from "../../assets/img/modals/integration-mailchimp.svg";
import integration_convertkit from "../../assets/img/modals/integration-convertkit.svg";
import integration_sendinblue from "../../assets/img/modals/integration-sendinblue.svg";
import integration_meet from "../../assets/img/modals/integration-meet.svg";
import integration_zapier from "../../assets/img/modals/integration-zapier.svg";
import integration_sheet from "../../assets/img/modals/integration-sheet.svg";
import integration_instantly from "../../assets/img/modals/integration-instantly.svg";
import { Modal } from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { hideLoader, showLoader } from "../loader";
import returnIcon from "../../assets/img/modals/return.svg";
import { useDispatch, useSelector } from "react-redux";
import ModalErrors from "../errors/modal-errors";
import { toast } from "react-toastify"
import { apiUrl } from "../../utils/url";
import { FacebookPixelModal, GoogleAnalyticsModal, ConvertkitModal, MailchimpModal, SendinblueModal, ConnectZapierModal, ConnectInstantlyModal } from "./integrations-modals";
import ConnectCalendarModal from "../connect-calendar-modal";
import getProducts from "../../services/getProducts";
import Teammoadal from "../teammember/team_modal";
import getProjects from "../../services/getProjects";
import SettingsHeader from "./settings-header";
import DynamicModal from "../../pages/dynamic-modal";

const IntegrationsPage = ({ setShowCustomizeParent }) => {
    const dispatch = useDispatch()
    const [show, setshow] = useState(false);
    const location = useLocation()
    const history = useHistory()
    const { subPath } = useParams();
    const { basePath, slug } = useSelector(state => state?.slugReducer);
    const isPro = useSelector(state => state?.proReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const customizePageReducer = useSelector(state => state?.customizePageReducer);
    const [integrationGoogleReducer, setIntegrationGoogle] = useState({ analytics_id: null, tab: "integrations", disconnect: 0 });
    const [integrationFacebookReducer, setIntegrationFacebook] = useState({ pixel_id: null, tab: "integrations", disconnect: 0 });
    const [integrationMailChimpReducer, setIntegrationMailchimp] = useState({ api_key: null, server_prefix: null, list_id: null, tab: "integrations", disconnect: 0 });
    const [integrationConvertkitReducer, setIntegrationConvertKit] = useState({ api_key: null, form_id: null, tab: "integrations", disconnect: 0 });
    const [integrationSendinblueReducer, setIntegrationSendinBlue] = useState({ api_key: null, list_id: null, tab: "integrations", disconnect: 0 });
    const { meet_token } = useSelector(state => state?.meetConnectedReducer);
    const [connectModal, setConnectModal] = useState(null);
    const [unlinkModal, setUnlinkModal] = useState(false);
    const encryptedProjectSlug = slug ? window.btoa(slug) : null;
    const [error, setError] = useState([]);
    const [allProducts, setallProducts] = useState([]);
    const [showModalasd, setShowModalasd] = useState(false)
    const planType = useSelector(state => state?.plantypeReducer);
    const integrationZapierReducer = useSelector(state => state?.integrationZapierReducer);
    const projectIntegrations = useSelector(state => state.projectIntegrationsReducer);

    const getIntegrations = () => {
        getProjects(slug).then((response) => {
            dispatch({ type: "SET_MEET_CONNECTED", payload: { meet_token: response?.meet_token ? true : false } });
            window.opener.postMessage({ type: 'meetToken', meetToken: response?.meet_token }, '*');
            let temp_obj = {};
            response?.settings?.map((val) => temp_obj = { ...temp_obj, [val?.key]: val?.value, project_id: val?.project_id });
            setIntegrationGoogle(temp_obj?.google_analytics?.length > 0 ? {
                analytics_id: temp_obj?.google_analytics,
                disconnect: 1
            } : { analytics_id: temp_obj?.google_analytics, })
            setIntegrationFacebook(temp_obj?.facebook_pixel?.length > 0 ? {
                pixel_id: temp_obj?.facebook_pixel,
                disconnect: 1
            } : { pixel_id: temp_obj?.facebook_pixel, })
            if (temp_obj?.mailchimp_settings)
                setIntegrationMailchimp({
                    ...JSON?.parse(temp_obj?.mailchimp_settings),
                    disconnect: 1
                })
            if (temp_obj?.convertkit_settings)
                setIntegrationConvertKit({
                    ...JSON?.parse(temp_obj?.convertkit_settings),
                    disconnect: 1
                })
            if (temp_obj?.sendinblue_settings)
                setIntegrationSendinBlue({
                    ...JSON?.parse(temp_obj?.sendinblue_settings),
                    disconnect: 1
                })
        })
    }
    const callAllProducts = () => {
        getProducts(slug).then((response) => {
            setallProducts(response);
        })
    }
    const meetConnected = allProducts?.data?.some(product => product?.calendar[0]?.meeting_location === 'google');
    const setParams = (tabName) => {
        showLoader()
        if (showModalasd) {
            setShowModalasd(true);
        }
        setTimeout(() => {
            hideLoader()
            setConnectModal(tabName);
        }, 300);
    }

    const diconnecting = (name, values, actionType) => {
        showLoader();
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const errorList = []
        const formdata = new FormData();
        const formValues = { project: slug, tab: "integrations", integration: name, disconnect: 1 };

        for (const key in formValues) {
            if (Object.hasOwnProperty.call(formValues, key)) {
                formdata.append(key, formValues[key]);
            }
        }

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(apiUrl + `/project/update`, requestOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {

                    // let temp_obj = { ...values }
                    // for (const key in temp_obj) {
                    //     if (Object.hasOwnProperty.call(temp_obj, key)) {
                    //         delete temp_obj["disconnect"];
                    //     }
                    dispatch({ type: actionType, payload: { ...values, [name]: null, account_name: null, disconnect: 0 } })
                    // }

                    toast.success(response?.status_message);
                    hideLoader();

                    setTimeout(() => {
                        handleClose(true)
                    }, 1000);
                }

                else {
                    let errorList = []
                    response?.errors?.link?.map((val) => errorList?.push(val));
                    response?.errors?.pixel_id?.map((val) => errorList?.push(val));
                    response?.errors?.analytics_id?.map((val) => errorList?.push(val));
                    toast.error(response?.status_message)
                    hideLoader()
                }
            }).catch((err) => {
                hideLoader()
            })
    }
    const handleClose = () => {
        setConnectModal(null)
    }
    const handleSubmit = (e, values, integration) => {
        if (!showModalasd) {
            e.preventDefault();
            showLoader();
            setError([]);
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const errorList = []
            const formdata = new FormData();
            let formValues = {};
            if (values?.disconnect == 1)
                formValues = { project: slug, tab: "integrations", integration: integration, disconnect: 1 };
            else
                formValues = { ...values, project: slug, integration: integration, tab: "integrations" };

            for (const key in formValues) {
                if (Object.hasOwnProperty.call(formValues, key)) {
                    formdata.append(key, formValues[key]);
                }
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
            };

            fetch(apiUrl + `/project/update`, requestOptions)
                .then(async (res) => {
                    const response = await res?.json();
                    if (response?.status_code == 200) {

                        toast.success(response?.status_message);
                        // if (integration == "mailchimp") {
                        //     dispatch({ type: "SET_MAILCHIMP_INTEGRATION", payload: { ...integrationMailChimpReducer, "disconnect": 1 } })
                        // }
                        // else if (integration == "convertkit") {
                        //     dispatch({ type: "SET_CONVERTKIT_INTEGRATION", payload: { ...integrationConvertkitReducer, "disconnect": 1 } })
                        // }
                        // else if (integration == "facebook") {
                        //     dispatch({ type: "SET_FACEBOOK_INTEGRATION", payload: { ...integrationFacebookReducer, "disconnect": 1 } })
                        // }
                        // else if (integration == "google") {
                        //     dispatch({ type: "SET_GOOGLE_INTEGRATION", payload: { ...integrationGoogleReducer, "disconnect": 1 } })
                        // }
                        // else if (integration == "sendinblue") {
                        //     dispatch({ type: "SET_SENDINBLUE_INTEGRATION", payload: { ...integrationSendinblueReducer, "disconnect": 1 } })
                        // } else 
                        if (integration == "lead_webhook") {
                            dispatch({ type: "SET_ZAPIER_INTEGRATION", payload: { ...integrationZapierReducer, lead_webhook: true, disconnect: true } })
                        }else{
                            dispatch({ type: 'SET_PROJECT_INTEGRATIONS', payload: {...projectIntegrations, [integration]:true}})
                        }
                        hideLoader();

                        setTimeout(() => {

                            // console.log("handleSubmit")
                            handleClose(true)

                        }, 1000);
                    }

                    else {
                        let errorList = []
                        response?.errors?.link?.map((val) => errorList?.push(val));
                        response?.errors?.pixel_id?.map((val) => errorList?.push(val));
                        response?.errors?.analytics_id?.map((val) => errorList?.push(val));
                        response?.errors?.api_key?.map((val) => errorList?.push(val));
                        // setError(errorList)

                        // console.log(errorList)

                        if (errorList.length !== 0) {

                            // console.log("Error List", errorList.length)
                            errorList?.map((err) => {
                                return (
                                    toast.error(err)
                                );
                            });
                        }
                        else {
                            toast.error(response?.status_message)
                        }

                        // toast.error(response?.status_message)
                        hideLoader()
                    }
                }).catch((err) => {
                    hideLoader()
                })
        }
    }
    const handleMeetButtonClick = async () => {
        try {
            localStorage.setItem("last_activity", location.pathname)
            showLoader();
            const response = await fetch(apiUrl + "/google-meet?redirectUrl=" + localStorage.getItem("last_activity") + '&project_slug=' + encryptedProjectSlug, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            if (response.status === 200) {
                const responseData = await response.json();
                // Redirect to the OAuth URL
                localStorage.setItem("openIntegrationPage", true);

                window.location.href = responseData.data.oauth_url;
            } else {
                // Handle errors here
                console.error("API Error:", response.statusText);
                hideLoader();
            }

        } catch (error) {
            // Handle fetch or other errors
            console.error("Error:", error);
            hideLoader();
        }
    };
    const handleDisconnectMeetButtonClick = async () => {
        if (meetConnected) {
            setUnlinkModal(true);
        } else {
            try {
                showLoader();
                const response = await fetch(apiUrl + "/disconnect-google-account?&project_slug=" + encryptedProjectSlug, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });

                const responseData = await response.json();
                if (responseData.status_code === 200) {
                    dispatch({ type: "SET_MEET_CONNECTED", payload: { meet_token: false } });
                    toast.success(responseData?.status_message);
                    hideLoader();
                } else {
                    // Handle errors here
                    console.error("API Error:", responseData.status_message);
                    hideLoader();
                }

            } catch (error) {
                // Handle fetch or other errors
                console.error("Error:", error);
                hideLoader();
            }
        }
    };
    const inputs = [
        {
            label: 'Spreadsheet URL',
            name: 'spreadsheet_url',
            type: 'url',
            placeholder: 'Enter URL',
            required: true,
        }
    ];
    const redirectToOAuth = async (param) => {
        try {
            showLoader();
            var response = await fetch(apiUrl + "/auth/" + param, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

             response = await response.json();
            if (response?.status_code === 200) {
                // Redirect to the OAuth URL
                localStorage.setItem("last_activity", location.pathname)
                localStorage.setItem("openIntegrationPage", true);
                localStorage?.setItem("slug",slug)
                localStorage?.setItem("google_sheets",true)
                window.location.href = response?.data?.oauth_url;
            } else {
                // Handle errors here
                hideLoader();
                toast.error("API Error:", response?.status_message);
            }

        } catch (error) {
            // Handle fetch or other errors
            console.error("Error:", error);
            hideLoader();
        }
    };
    return (
        <>
            <section class="container customize-page-main int-3-b position-relative newpadding">
            <SettingsHeader page={"Integrations"} activePage={'integrations'} description={'Connect apps and services to your GenPage workspace'}/>                

                <div class="cent-cont-u">
                    <div class="d-flex align-items-center justify-content-start flex-wrap gap-2">
                        <div class="integration-card zapier-integration-card">
                            <div className="icon-shadow">
                                <img src={integration_zapier} alt="" />
                            </div>
                            <div class="mt10-u fs-16">Zapier</div>
                            <div class="fs-12">Export to Zapier</div>
                            {
                                (!integrationZapierReducer?.disconnect) ?
                                    <button type="submit" onClick={() => setParams("lead_webhook")} className="gradient-btns">
                                        <span>Connect</span>
                                        <small className="gradient-btns-badge">
                                            <img src={returnIcon} alt="" />
                                        </small>
                                    </button>
                                    :

                                    <button onClick={() => diconnecting("lead_webhook", integrationZapierReducer, "SET_ZAPIER_INTEGRATION")}
                                        class="integration-btns integration-btn-grey mt-20px">
                                        Disconnect
                                    </button>
                            }
                        </div>
                        <div class="integration-card instantly-integration-card">
                            <div className="icon-shadow">
                                <img src={integration_instantly} alt="" />
                            </div>
                            <div class="mt10-u fs-16">Instantly</div>
                            <div class="fs-12">Export To Instantly</div>
                            {
                                (!projectIntegrations?.instantly) ?
                                    <button type="submit" onClick={() => setParams('instantly')} className="gradient-btns">
                                        <span>Connect</span>
                                        <small className="gradient-btns-badge">
                                            <img src={returnIcon} alt="" />
                                        </small>
                                    </button>
                                    :

                                    <button onClick={() => diconnecting("instantly", projectIntegrations, "SET_PROJECT_INTEGRATIONS")}
                                        class="integration-btns integration-btn-grey mt-20px font-weight-400">
                                        Disconnect
                                    </button>
                            }
                        </div>
                        <div class="integration-card sheet-integration-card">
                            <div className="icon-shadow">
                                <img src={integration_sheet} alt="" />
                            </div>
                            <div class="mt10-u fs-16">Google Sheets</div>
                            <div class="fs-12">Export to Google Spreadsheet</div>
                            {
                                (!projectIntegrations?.google_sheets) ?
                                    <button type="submit" onClick={() => redirectToOAuth('google')} className="gradient-btns">
                                        <span>Connect</span>
                                        <small className="gradient-btns-badge">
                                            <img src={returnIcon} alt="" />
                                        </small>
                                    </button>
                                    :

                                    <button onClick={() => diconnecting("google_sheets", projectIntegrations, "SET_PROJECT_INTEGRATIONS")}
                                        class="integration-btns integration-btn-grey mt-20px font-weight-400">
                                        Disconnect
                                    </button>
                            }
                        </div>
                    </div>
                </div>
                {showModalasd && <Teammoadal showModal={showModalasd} text={'Integrations is a Pro feature. <br /> Upgrade to Zaap Pro to unlock this feature.'} isUltra={false} />}
            </section>
            {connectModal == "lead_webhook" && <ConnectZapierModal type={"lead_webhook"} text="Leads" show={true} setShowCustomizeParent={setShowCustomizeParent} handleSubmit={handleSubmit} error={error} handleClose={handleClose} />}
            {connectModal == "instantly" && <ConnectInstantlyModal type={"instantly"} show={true} setShowCustomizeParent={setShowCustomizeParent} handleSubmit={handleSubmit} error={error} handleClose={handleClose} />}
            {/* {connectModal == "facebookPixel" && <FacebookPixelModal show={true} setShowCustomizeParent={setShowCustomizeParent} handleSubmit={handleSubmit} error={error} handleClose={handleClose} />}
            {connectModal == "mailchimp" && <MailchimpModal show={true} setShowCustomizeParent={setShowCustomizeParent} handleSubmit={handleSubmit} error={error} handleClose={handleClose} />}
            {connectModal == "convertkit" && <ConvertkitModal show={true} setShowCustomizeParent={setShowCustomizeParent} handleSubmit={handleSubmit} error={error} handleClose={handleClose} />}
            {connectModal == "sendinblue" && <SendinblueModal show={true} setShowCustomizeParent={setShowCustomizeParent} handleSubmit={handleSubmit} error={error} handleClose={handleClose} />} */}
            <ConnectCalendarModal show={unlinkModal} setShow={setUnlinkModal} TwoButtons={false} text={"This Google Account is being used for existing products. Please unlink Google Meet from your products before continuing"} />
        </>
    )
}

export default IntegrationsPage;
